<script setup>

import { useRoute, useRouter } from 'vue-router';
import { isEmpty, isNil } from 'ramda';
import Trans from '@/i18n/translation';
import FetchPlanCardsComponent from '@/components/FetchPlanCardsComponent.vue';

const emit = defineEmits(['planChosen', 'back']);

const route = useRoute();
const router = useRouter();

const plansFetched = (plans) => {
  const givenPlanByQuery = route.query.plan;
  if (givenPlanByQuery !== undefined) {
    const foundPlan = plans.value.find((p) => !p.needsContact && p.name === givenPlanByQuery);
    if (!isEmpty(foundPlan) && !isNil(foundPlan)) {
      emit('planChosen', foundPlan);
      // remove query param because we 'consumed' it already
      router.replace({ query: null });
    }
  }
};

</script>

<template>
  <h2 class="text-3xl text-center text-basecolor">
    {{ $t('registerView.selectSubscription') }}
  </h2>

  <div
    class="isolate mx-auto mt-12 grid max-w-md grid-cols-1 gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4"
  >
    <p class="text-sm mt-6 mb-3 text-basecolor col-span-1 md:col-span-2 xl:col-span-5">
      {{ $t('registerView.loginHint') }}
      <RouterLink
        class="font-bold"
        :to="Trans.i18nRoute({name: 'login'})"
      >
        {{ $t('logIn') }}
      </RouterLink>
    </p>
  </div>

  <FetchPlanCardsComponent
    :use-callback="true"
    @plan-chosen="emit('planChosen', $event)"
    @fetching-done="plansFetched"
  />

  <button
    class="mt-8 text-xs text-basecolor"
    @click="$emit('back')"
  >
    <span>
      {{ $t('registerView.goBack') }}
    </span>
  </button>
</template>

<style scoped>

</style>
